import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';

export const useIsAdmin = () => {
  return trpc.admin.isAdmin.useQuery(undefined, {
    retry: false,
    cacheTime: CACHE_TIME,
    staleTime: STALE_TIME,
    enabled: true,
  });
};
